import { axios } from '@/plugins/axios';

export const getLimitCategories = () => axios.get(`/limit-categories`)
  .then(res => res.data);